module.exports = __webpack_public_path__ + "img/ContactUs_Desktop_01.2e79ac90.jpg";